<script>
import Layout from '@layouts/main'
import { authComputed } from '@state/helpers'
import i18n from '@src/plugins/i18n'

const t = (key, p) => i18n.global.t(key, p || {})

export default {
  metaInfo() {
    return {
      title: this.$t('notFound.metaTitle'),
      meta: [
        { name: 'description', content: this.$t('notFound.metaDescription') },
      ],
    }
  },
  components: { Layout },
  props: {
    // Optionally names what was missing (e.g. "Quiz" from an unknown training
    // slug) so the copy can be specific instead of generic.
    resource: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...authComputed,
    message() {
      if (this.resource) {
        return t('notFound.messageResource', {
          resource: this.resource.toLowerCase(),
        })
      }
      return t('notFound.messageGeneric')
    },
  },
}
</script>

<template>
  <Layout>
    <v-row align="center" justify="center" class="notfound-row">
      <v-col cols="12" sm="8" md="6" lg="5">
        <v-card
          variant="flat"
          border
          rounded="lg"
          class="notfound-card mx-auto text-center"
        >
          <v-card-text class="pa-10">
            <div class="notfound-code font-weight-bold">404</div>
            <h1 class="text-h5 font-weight-bold mt-2">
              {{
                resource
                  ? $t('notFound.titleResource', { resource })
                  : $t('notFound.titleGeneric')
              }}
            </h1>
            <p class="text-body-2 text-medium-emphasis mt-2 mb-8">
              {{ message }}
            </p>
            <div class="d-flex justify-center flex-wrap ga-3">
              <v-btn
                v-if="loggedIn"
                color="brand"
                variant="flat"
                prepend-icon="$dashboard"
                :to="{ name: 'dashboard' }"
              >
                {{ $t('notFound.goToDashboard') }}
              </v-btn>
              <v-btn
                v-else
                color="brand"
                variant="flat"
                prepend-icon="$home"
                :to="{ name: 'home' }"
              >
                {{ $t('notFound.goHome') }}
              </v-btn>
              <v-btn color="brand" variant="text" @click="$router.back()">
                {{ $t('notFound.goBack') }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </Layout>
</template>

<style scoped>
/* Center the card in the space between the app bar and footer. */
.notfound-row {
  min-height: calc(100vh - 260px);
}

.notfound-card {
  max-width: 480px;
}

/* An oversized, quiet brand-red code. Identity without alarm. */
.notfound-code {
  font-size: 88px;
  line-height: 1;
  color: rgb(var(--v-theme-brand));
  opacity: 0.85;
  letter-spacing: -0.02em;
}
</style>
